import { useApplicationContext } from '../../../../../../../context/ApplicationContext/ApplicationContext';
import { useChatContext } from '../../../../../../contexts/chat/chat.context';
import ChatHeaderTemplate from '../../../../../ChatHeaderTemplate/ChatHeaderTemplate';

const ChatRoomsHeader = () => {
  const { goToGroupedRooms, rooms, selectedGroupOfRooms } = useChatContext();

  const { isStore } = useApplicationContext();

  const canGoBack = rooms.length > 1;

  const getTitle = () => {
    if (!selectedGroupOfRooms) {
      return '';
    }

    return isStore
      ? selectedGroupOfRooms.brandInfo.commercialName
      : selectedGroupOfRooms.storeInfo?.commercialName || '';
  };

  return (
    <ChatHeaderTemplate.Template onClickGoBack={canGoBack ? goToGroupedRooms : undefined}>
      <ChatHeaderTemplate.Title text={getTitle()} />
    </ChatHeaderTemplate.Template>
  );
};

export default ChatRoomsHeader;
